import React from "react";
import { useLocation } from "react-router-dom";
import VeridianBadge from "../VeridianBadge";

/* â”€â”€ Route map â€” add only, never remove links â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const NAV_GROUPS = [
  {
    label: "Core",
    items: [
      { path: "/",             icon: "space_dashboard",   label: "Command Center" },
      { path: "/whatsapp",     icon: "chat",              label: "WhatsApp" },
      { path: "/crm",          icon: "contacts",          label: "CRM" },
//       { path: "/setup",        icon: "settings",          label: "Setup" }, // TODO: add route
    ],
  },
  {
    label: "Commerce",
    items: [
      { path: "/inventory",    icon: "inventory_2",       label: "Inventory" },
      { path: "/shopify",      icon: "storefront",        label: "Shopify" },
      { path: "/pricing",      icon: "sell",              label: "Pricing" },
      { path: "/marketplace",  icon: "hub",               label: "Marketplace" },
      { path: "/accounting",   icon: "receipt_long",      label: "AfaqBooks" },
      { path: "/b2b-tiers",    icon: "diversity_3",       label: "B2B Tiers" },
      { path: "/email",        icon: "mail",              label: "Email Intel" },
//       { path: "/theme",        icon: "palette",           label: "Theme Studio" }, // TODO: add route
//       { path: "/discount",     icon: "local_offer",       label: "Discounts" }, // TODO: add route
    ],
  },
  {
    label: "Intelligence",
    items: [
      { path: "/seo",          icon: "query_stats",       label: "SEO Intel" },
      { path: "/voice-sales",  icon: "graphic_eq",        label: "Voice Sales" },
      { path: "/market-intel", icon: "insights",          label: "Market Intel" },
      { path: "/leads",        icon: "person_search",     label: "Leads" },
      { path: "/ai",           icon: "psychology",        label: "AI Center" },
      { path: "/content",      icon: "auto_awesome_motion", label: "Content AI" },
      { path: "/agents",       icon: "smart_toy",         label: "Agent Hub" },
      { path: "/automation",   icon: "smart_toy",         label: "Automation" },
      { path: "/veridian",     icon: "auto_awesome",      label: "Veridian Ginie" },
      { path: "/omnivoice",    icon: "surround_sound",    label: "OmniVoice" },
      { path: "/crawler",      icon: "radar",             label: "Crawler" },
      { path: "/genie",        icon: "monitor_heart",     label: "Genie Pulse" },
//       { path: "/calendar",     icon: "calendar_month",    label: "GCC Calendar" }, // TODO: add route
    ],
  },
  {
    label: "People",
    items: [
      { path: "/attendance",   icon: "fingerprint",       label: "Attendance" },
      { path: "/hr",           icon: "badge",             label: "HR" },
      { path: "/commission",   icon: "payments",          label: "Commission" },
      { path: "/my-dashboard", icon: "person",            label: "My Dashboard" },
    ],
  },
  {
    label: "System",
    items: [
      { path: "/admin",        icon: "shield",            label: "Admin" },
      { path: "/integrations", icon: "cable",             label: "Integrations" },
      { path: "/gpu",          icon: "memory",            label: "GPU Intelligence" },
      { path: "/phone-bridge", icon: "phonelink",         label: "Phone Bridge" },
      { path: "/help",         icon: "help",              label: "Help Centre" },
      { path: "/profile",      icon: "manage_accounts",   label: "Profile" },
      { path: "/harmony",      icon: "sensors",           label: "HARMONY" },
    ],
  },
];

const Sidebar: React.FC = () => {
  const { pathname } = useLocation();
  const isActive = (path: string) =>
    path === "/" ? pathname === "/" : pathname.startsWith(path);

  return (
    <aside className="afaq-sidebar m27-sidebar">
      {/* Brand */}
      <div className="m27-sidebar-brand">
        <div className="m27-sidebar-brand-title">Celestial OS</div>
        <div className="m27-sidebar-brand-sub">Enterprise Intelligence</div>
      </div>

      {/* Deploy CTA */}
      <button className="m27-sidebar-deploy-btn">
        <span className="material-symbols-outlined" style={{ fontSize: 13, verticalAlign: "middle", marginRight: 5 }}>electric_bolt</span>
        Deploy Insight
      </button>

      {/* Nav groups */}
      <nav style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {NAV_GROUPS.map((group) => (
          <div key={group.label}>
            <div className="m27-nav-group-label">{group.label}</div>
            {group.items.map(({ path, icon, label }) => {
              const active = isActive(path);
              return (
                <a
                  key={path}
                  href={path}
                  className={`sidebar-link m27-nav-item${active ? " m27-nav-item--active" : ""}`}
                  aria-current={active ? "page" : undefined}
                >
                  <span className="material-symbols-outlined" style={{ fontSize: 17, flexShrink: 0 }}>
                    {icon}
                  </span>
                  <span>{label}</span>
                  {path === "/veridian" && (
                    <VeridianBadge size={14} tooltip="Integrated by Veridian" />
                  )}
                </a>
              );
            })}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div style={{ paddingTop: 12, borderTop: "0.5px solid rgba(189,178,255,0.08)", marginTop: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 12px" }}>
          <span className="material-symbols-outlined" style={{ fontSize: 13, color: "rgba(221,229,255,0.25)" }}>terminal</span>
          <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 10, textTransform: "uppercase", letterSpacing: "0.1em", color: "rgba(221,229,255,0.25)" }}>Logs</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "4px 12px 8px" }}>
          <span className="m27-dot m27-dot--secondary" style={{ animation: "m27-sonic-pulse 2s ease-out infinite" }} />
          <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 10, textTransform: "uppercase", letterSpacing: "0.1em", color: "rgba(207,237,162,0.6)" }}>System Online</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;


